// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"ProductName_titleWrapper__W_GO0","title":"ProductName_title__pLJTU","info":"ProductName_info__b7OEY"};